export default __webpack_public_path__ + "static/media/mon_64.8447cc04.png";